const STORAGE_KEY = 'position-app.config';

export interface AppConfig {
    alpacaKeyId: string;
    alpacaSecret: string;
    alpacaPaper: boolean;
    primaryApiUrl: string;
    fallbackApiUrl: string;
    apiKey: string;
    userId: string;
}

export const defaultConfig = (): AppConfig => ({
    alpacaKeyId: '',
    alpacaSecret: '',
    alpacaPaper: true,
    primaryApiUrl: '',
    fallbackApiUrl: '',
    apiKey: '',
    userId: '',
});

export const parseConfigJson = (raw: string): AppConfig => {
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        throw new Error('Config JSON must be an object.');
    }
    return { ...defaultConfig(), ...(parsed as Partial<AppConfig>) };
};

export const getConfig = (): AppConfig | null => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) {
        return null;
    }

    try {
        return parseConfigJson(raw);
    } catch {
        return null;
    }
};

export const saveConfig = (config: AppConfig): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
};

export const clearConfig = (): void => {
    localStorage.removeItem(STORAGE_KEY);
};

export const isConfigured = (config: AppConfig | null): config is AppConfig =>
    config != null &&
    config.alpacaKeyId !== '' &&
    config.alpacaSecret !== '' &&
    config.primaryApiUrl !== '' &&
    config.apiKey !== '' &&
    config.userId !== '';
